import { NgModule } from '@angular/core'
import { provideTransloco, TranslocoConfig, TranslocoModule } from '@jsverse/transloco'
import { TranslocoRootComponent } from './transloco-root.component'
import { TranslocoHttpLoader } from './transloco-http.loader'
import { CommonModule } from '@angular/common'
import { environment } from '../environments/environment'

const translocoConfig: Partial<TranslocoConfig> = {
  availableLangs: ['cs'],
  defaultLang: 'cs',
  reRenderOnLangChange: false,
  prodMode: environment.production,
  missingHandler: {
    logMissingKey: !environment.production,
    useFallbackTranslation: false,
    allowEmpty: true,
  },
}

@NgModule({
  declarations: [],
  imports: [CommonModule, TranslocoModule, TranslocoRootComponent],
  exports: [TranslocoRootComponent, TranslocoModule],
  providers: [
    provideTransloco({
      config: translocoConfig,
      loader: TranslocoHttpLoader,
    }),
  ],
})
export class TranslocoRootModule {}
